var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showPopup
      ? _c("div", { staticClass: "popup-overlay" }, [
          _c("div", { staticClass: "popup-content" }, [
            _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "margin-bottom": "10px"
                }
              },
              [
                _c("h6", [
                  _vm._v(
                    _vm._s(
                      _vm.$resourceString["product.search.pdf.modal.heading"]
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "popup-close-button",
                    on: { click: _vm.closePopup }
                  },
                  [
                    _c("span", {
                      staticClass: "png-icon png-icon-icons-symbols--k-txtclose"
                    })
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", [
              _c("p", [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.$resourceString["product.search.pdf.modal.body"]
                    ) +
                    "\n                "
                )
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }